import http from '../../utils/Http/Http'

export type CreatePropLeadParams = {
	email: string
	phoneNumber: string
	utm?: {
		utm_source?: string
		utm_medium?: string
		utm_term?: string
		utm_content?: string
	}
}

export const createPropLead = async ({ email, phoneNumber, utm }: CreatePropLeadParams) => {
	const response = await http({
		url: '/crm/ghl/prop_lead',
		method: 'post',
		data: {
			email,
			utm,
			phone_number: phoneNumber,
		},
	})

	return response.data
}
